var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { inject, observer } from 'mobx-react';
import { Box, Button, Card, CardContent, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, ListItemText, Modal, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import MenuIcon from '@mui/icons-material/Menu';
import DeleteIcon from '@mui/icons-material/Delete';
var OrganizationGroups = /** @class */ (function (_super) {
    __extends(OrganizationGroups, _super);
    function OrganizationGroups(props) {
        var _this = _super.call(this, props) || this;
        Object.defineProperty(_this, "createNewGroup", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, organizationGroupStore, organizationId, newGroupName;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = this.props, organizationGroupStore = _a.organizationGroupStore, organizationId = _a.organizationId;
                            newGroupName = this.state.newGroupName;
                            if (!(organizationGroupStore && newGroupName.trim())) return [3 /*break*/, 2];
                            return [4 /*yield*/, organizationGroupStore.addGroup(organizationId, newGroupName)];
                        case 1:
                            _b.sent();
                            this.closeModal();
                            _b.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            }); }
        });
        _this.state = {
            isModalOpen: false,
            newGroupName: ''
        };
        return _this;
    }
    Object.defineProperty(OrganizationGroups.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            var items = (_b = (_a = this.props.organizationGroupStore) === null || _a === void 0 ? void 0 : _a.groups) !== null && _b !== void 0 ? _b : [];
            var _k = this.state, isModalOpen = _k.isModalOpen, newGroupName = _k.newGroupName;
            return (_jsxs("div", __assign({ className: "organization-group-root" }, { children: [_jsx(Grid, __assign({ className: "organization-group-filter" }, { children: _jsxs(Grid, __assign({ item: true, xs: 3, container: true, direction: "row", alignItems: "left" }, { children: [_jsx(Button, __assign({ variant: "contained", startIcon: _jsx(AddCircleIcon, {}, void 0), onClick: function (e) { return _this.openModal(); }, className: "self-align-center" }, { children: (_c = this.props.languageStore) === null || _c === void 0 ? void 0 : _c.getLabel('OrganizationGroups.CreateNew') }), void 0), this.renderConfirmDeleteDialog()] }), void 0) }), void 0), _jsx("div", __assign({ className: "organization-group-container" }, { children: ((_d = this.props.organizationGroupStore) === null || _d === void 0 ? void 0 : _d.isBusy)
                            ? _jsx("div", __assign({ className: "organization-group-progress" }, { children: _jsx(CircularProgress, {}, void 0) }), void 0)
                            :
                                _jsxs(Table, { children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, __assign({ style: this.buildCellStyle(250) }, { children: _jsx("div", __assign({ className: "flex-row align-" }, { children: _jsx("span", { children: (_e = this.props.languageStore) === null || _e === void 0 ? void 0 : _e.getLabel('OrganizationGroups.Name') }, void 0) }), void 0) }), void 0), _jsx(TableCell, __assign({ style: this.buildCellStyle(250) }, { children: _jsx("div", __assign({ className: "flex-row align-center" }, { children: _jsx("span", { children: (_f = this.props.languageStore) === null || _f === void 0 ? void 0 : _f.getLabel('OrganizationGroups.CaseTypes') }, void 0) }), void 0) }), void 0), _jsx(TableCell, __assign({ style: this.buildCellStyle(700) }, { children: _jsx("div", __assign({ className: "flex-row align-center" }, { children: _jsx("span", { children: (_g = this.props.languageStore) === null || _g === void 0 ? void 0 : _g.getLabel('OrganizationGroups.Users') }, void 0) }), void 0) }), void 0), _jsx(TableCell, __assign({ style: this.buildCellStyle(100) }, { children: _jsxs("div", __assign({ className: "flex-row align-center" }, { children: [_jsx(MenuIcon, {}, void 0), _jsx("span", { children: (_h = this.props.languageStore) === null || _h === void 0 ? void 0 : _h.getLabel('OrganizationGroups.Actions') }, void 0)] }), void 0) }), void 0)] }, void 0) }, void 0), _jsx(TableBody, { children: (_j = items.map(function (group, index) { return (_jsxs(TableRow, { children: [_jsx(TableCell, { children: _jsx("div", __assign({ className: "flex-row align-center" }, { children: _jsx("input", { className: "form-control", value: group.name, onChange: function (e) { return _this.updateGroupName(e, index); } }, void 0) }), void 0) }, void 0), _jsx(TableCell, { children: _jsx(Stack, __assign({ direction: "column" }, { children: group.caseTypes.map(function (caseType, ctIndex) { return (_jsxs(Box, __assign({ p: 1, display: "flex", alignItems: "center" }, { children: [_jsx(Checkbox, { checked: caseType.isSelected, onChange: function () { return _this.onCaseTypeCheckChanged(index, ctIndex); } }, void 0), _jsx(ListItemText, { primary: caseType.name }, void 0)] }), ctIndex)); }) }), void 0) }, void 0), _jsx(TableCell, { children: _jsx(Stack, __assign({ spacing: 1, direction: "row", flexWrap: "wrap" }, { children: group.users.map(function (user, userIndex) { return (_jsxs(Box, __assign({ p: 1, display: "block" }, { children: [_jsx(Checkbox, { checked: user.isSelected, onChange: function () { return _this.onUserCheckChanged(index, userIndex); } }, void 0), _jsx(ListItemText, { primary: user.name }, void 0)] }), userIndex)); }) }), void 0) }, void 0), _jsx(TableCell, { children: _jsx("div", __assign({ className: "flex-row align-center" }, { children: _jsx(IconButton, __assign({ color: "primary", size: "small", onClick: function () { return _this.onDeleteClick(group.id); } }, { children: _jsx(DeleteIcon, {}, void 0) }), void 0) }), void 0) }, void 0)] }, group.id)); })) !== null && _j !== void 0 ? _j : _jsx("span", { children: "No items" }, void 0) }, void 0)] }, void 0) }), void 0), _jsx(Modal, __assign({ open: isModalOpen, onClose: this.closeModal }, { children: _jsxs(Box, __assign({ sx: modalStyle }, { children: [_jsx("h2", { children: "Create New Group" }, void 0), _jsx(TextField, { label: "Group Name", value: newGroupName, onChange: function (e) { return _this.setState({ newGroupName: e.target.value }); }, fullWidth: true }, void 0), _jsxs(Stack, __assign({ direction: "row", spacing: 2, mt: 2 }, { children: [_jsx(Button, __assign({ variant: "contained", onClick: function () { return _this.createNewGroup(); } }, { children: "Create" }), void 0), _jsx(Button, __assign({ variant: "outlined", onClick: function () { return _this.closeModal(); } }, { children: "Cancel" }), void 0)] }), void 0)] }), void 0) }), void 0)] }), void 0));
        }
    });
    Object.defineProperty(OrganizationGroups.prototype, "buildCellStyle", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (width) {
            return {
                width: width,
                maxWidth: width,
                minWidth: width,
                overflow: 'hidden'
            };
        }
    });
    Object.defineProperty(OrganizationGroups.prototype, "onCaseTypeCheckChanged", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (groupIndex, caseTypeIndex) {
            var organizationGroupStore = this.props.organizationGroupStore;
            if (organizationGroupStore) {
                organizationGroupStore.setGroupCaseType(groupIndex, caseTypeIndex);
            }
        }
    });
    Object.defineProperty(OrganizationGroups.prototype, "onUserCheckChanged", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (groupIndex, userIndex) {
            var organizationGroupStore = this.props.organizationGroupStore;
            if (organizationGroupStore) {
                organizationGroupStore.setUserGroup(groupIndex, userIndex);
            }
        }
    });
    Object.defineProperty(OrganizationGroups.prototype, "addNewGroup", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            return __awaiter(this, void 0, void 0, function () {
                var organizationGroupStore;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            organizationGroupStore = this.props.organizationGroupStore;
                            if (!organizationGroupStore) return [3 /*break*/, 2];
                            return [4 /*yield*/, organizationGroupStore.addGroup(this.props.organizationId || '', '')];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(OrganizationGroups.prototype, "removeGroup", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (id) {
            return __awaiter(this, void 0, void 0, function () {
                var organizationGroupStore;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            organizationGroupStore = this.props.organizationGroupStore;
                            if (!organizationGroupStore) return [3 /*break*/, 2];
                            return [4 /*yield*/, organizationGroupStore.removeGroup(id)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(OrganizationGroups.prototype, "updateGroupName", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e, index) {
            return __awaiter(this, void 0, void 0, function () {
                var organizationGroupStore, groups;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            organizationGroupStore = this.props.organizationGroupStore;
                            if (!organizationGroupStore) return [3 /*break*/, 2];
                            groups = __spreadArray([], organizationGroupStore.groups, true);
                            groups[index].name = e.target.value;
                            return [4 /*yield*/, organizationGroupStore.updateGroup(groups[index], groups)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(OrganizationGroups.prototype, "onDeleteClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (id) {
            this.setState(__assign(__assign({}, this.state), { deleteItemId: id }));
        }
    });
    Object.defineProperty(OrganizationGroups.prototype, "renderConfirmDeleteDialog", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            return (_jsxs(Dialog, __assign({ open: this.state.deleteItemId !== undefined, onClose: function () { return _this.onCloseConfirm(false); } }, { children: [_jsx(DialogTitle, { children: "Confirmation" }, void 0), _jsx(DialogContent, __assign({ sx: { minWidth: '300px' } }, { children: _jsx(Card, { children: _jsx(CardContent, { children: "Do you wish to delete this item?" }, void 0) }, void 0) }), void 0), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ variant: "contained", color: "warning", onClick: function () { return _this.onCloseConfirm(true); } }, { children: "Yes" }), void 0), _jsx(Button, __assign({ variant: "outlined", onClick: function () { return _this.onCloseConfirm(false); } }, { children: "No" }), void 0)] }, void 0)] }), void 0));
        }
    });
    Object.defineProperty(OrganizationGroups.prototype, "closeModal", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.setState({ isModalOpen: false });
        }
    });
    Object.defineProperty(OrganizationGroups.prototype, "openModal", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.setState({ isModalOpen: true });
        }
    });
    Object.defineProperty(OrganizationGroups.prototype, "onCloseConfirm", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (isConfirmed) {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            this.setState(__assign(__assign({}, this.state), { deleteItemId: undefined }));
                            if (!isConfirmed) return [3 /*break*/, 2];
                            return [4 /*yield*/, ((_a = this.props.organizationGroupStore) === null || _a === void 0 ? void 0 : _a.removeGroup(this.state.deleteItemId))];
                        case 1:
                            _b.sent();
                            _b.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        }
    });
    OrganizationGroups = __decorate([
        inject('languageStore'),
        inject('organizationGroupStore'),
        observer
    ], OrganizationGroups);
    return OrganizationGroups;
}(React.Component));
export default OrganizationGroups;
var modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
